import Vue from 'vue';
import Vuex from 'vuex';

// Load store modules dynamically.
import account from './modules/account';
import settings from './modules/settings';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    account,
    settings,
  },
  actions: {
    initialiseStore({ commit, dispatch }) {
      dispatch('account/init');
      dispatch('settings/init');
    },
  },
});
